import * as React from 'react';
import { CSSProperties, useEffect, useState } from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from '@/lib/utils';
import styles from './ToolTip.module.less';

const Tooltip: React.FC<{
  children: React.ReactNode;
  content: React.ReactNode;
  maxWidth?: CSSProperties['maxWidth'];
}> = ({ children, content, maxWidth = '300px' }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  // 检测是否为移动端
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // 移动端点击处理
  const handleMobileClick = () => {
    if (isMobile) {
      setIsOpen(!isOpen);
    }
  };

  return (
    <TooltipPrimitive.Provider delayDuration={isMobile ? 0 : 100}>
      <TooltipPrimitive.Root
        open={isMobile ? isOpen : undefined}
        onOpenChange={setIsOpen}
      >
        <TooltipPrimitive.Trigger asChild onClick={handleMobileClick}>
          {children}
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            className={cn(
              styles.tooltipContent,
              isMobile && styles.mobile
            )}
            style={{ '--tooltip-max-width': maxWidth } as CSSProperties}
            sideOffset={5}
            // 移动端点击外部关闭
            onPointerDownOutside={isMobile ? () => setIsOpen(false) : undefined}
          >
            {content}
            <TooltipPrimitive.Arrow />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};

export default Tooltip;
